import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initFavicon } from './lib/favicon';
import { applyTheme } from './lib/theme';
import { SignPage } from './views/SignPage';
import './styles/index.css';

initFavicon();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root');

// Public signing page: reachable only via a magic-link token at /sign/:token,
// rendered standalone (no auth, no app shell). The SPA static fallback serves
// index.html for this path, so routing is resolved here on the client.
const signMatch = window.location.pathname.match(/^\/sign\/(.+)$/);

createRoot(rootEl).render(
  <React.StrictMode>
    {signMatch ? <SignBoot token={decodeURIComponent(signMatch[1]!)} /> : <App />}
  </React.StrictMode>,
);

function SignBoot({ token }: { token: string }) {
  // The public visitor has no stored theme; apply a sensible default.
  applyTheme('dark-lima');
  return <SignPage token={token} />;
}
